import { ExpenseStatusEnum } from 'common/components/molecules/ExpenseStatus/ExpenseStatus';

export const ReviewedExpenseStatuses = [
  ExpenseStatusEnum.APPROVED,
  ExpenseStatusEnum.REJECTED,
  ExpenseStatusEnum.INFO_NEEDED,
  ExpenseStatusEnum.PAID,
];
